import { getTokenExpiryMs } from "@/services/auth/decodeJwtPayload";

const REFRESH_BEFORE_EXPIRY_MS = 60_000;

let refreshTimer: ReturnType<typeof setTimeout> | null = null;

export function cancelScheduledTokenRefresh(): void {
  if (refreshTimer) {
    clearTimeout(refreshTimer);
    refreshTimer = null;
  }
}

export function scheduleTokenRefresh(token: string): void {
  cancelScheduledTokenRefresh();

  const expiresAtMs = getTokenExpiryMs(token);

  if (!expiresAtMs) {
    return;
  }

  const refreshAtMs = expiresAtMs - REFRESH_BEFORE_EXPIRY_MS;
  const delay = refreshAtMs - Date.now();

  if (delay <= 0) {
    void triggerProactiveRefresh();
    return;
  }

  refreshTimer = setTimeout(() => {
    refreshTimer = null;
    void triggerProactiveRefresh();
  }, delay);
}

async function triggerProactiveRefresh(): Promise<void> {
  const { refreshTokens } = await import("@/services/auth/authTokenRefresh");

  try {
    await refreshTokens();
  } catch {
    // refreshTokens handles logout on failure; 401 interceptor remains as fallback
  }
}
